export const INTEGRATION_PROVIDER_TABS = {
  configuration: 'configuration',
  entityMapping: 'entityMapping',
} as const;
  
export type IntegrationProviderTab = typeof INTEGRATION_PROVIDER_TABS[keyof typeof INTEGRATION_PROVIDER_TABS];